import React from "react";
import { appDomain, appEmit } from "../../domain/AppDomain";
import { AppRoutes } from "../../domain/navigation/AppRoutes";
import { BaseComponent } from "../core/BaseComponent";
import { AttentionDaysTable } from "./AttentionDaysTable";
import { EventNames } from "../../domain/events/Events";

export class AttentionDays extends BaseComponent<{}, any> {
    async importAttentionDays() {
        await appDomain.IAttentionDayService.importAttentionDays();
        appEmit(EventNames.reloadAttentiondays);
        window.alert("Attentiedagen geimporteerd");
    }
    navigate = () => this.navigateTo(`${AppRoutes.attentiondays}/new`)

    render() {
        return (<div className="attentiondays">
            <div className="toolbar">
                <button className="default-button clickable" onClick={this.importAttentionDays.bind(this)}>{this.translate("attentiondays.import")}</button>
                <button className="default-button clickable" onClick={this.navigate.bind(this)}>{this.translate("attentiondays.new")}</button>
            </div>
            <AttentionDaysTable />

        </div>);
    }
}
